import * as React from 'react';
import { withCompController } from '@wix/editor-elements-integrations';
import {
  AnalyticsClicksGroups,
  isExperimentOpen,
  tryReportAnalyticsClicksBi,
} from '@wix/editor-elements-common-utils';
import type {
  IStylableHorizontalMenuProps,
  StylableHorizontalMenuControllerProps,
  StylableHorizontalMenuMapperProps,
  StylableHorizontalMenuStateRefs,
} from '../StylableHorizontalMenu.types';

const compController = withCompController<
  StylableHorizontalMenuMapperProps,
  StylableHorizontalMenuControllerProps,
  IStylableHorizontalMenuProps,
  StylableHorizontalMenuStateRefs
>(({ stateValues, mapperProps }) => {
  const { currentUrl, reportBi, experiments = {} } = stateValues;
  const {
    compId,
    language,
    mainPageId,
    trackClicksAnalytics,
    ...restMapperProps
  } = mapperProps;

  const reportBiOnMenuItemClick: StylableHorizontalMenuControllerProps['reportBiOnMenuItemClick'] =
    React.useCallback(
      (event: React.SyntheticEvent, item: any = {}) => {
        tryReportAnalyticsClicksBi(reportBi, {
          link: item.link,
          language,
          trackClicksAnalytics,
          elementTitle: item.label,
          pagesMetadata: { mainPageId },
          element_id: compId ?? event.currentTarget.id,
          elementType: restMapperProps.fullNameCompType,
          elementGroup: AnalyticsClicksGroups.MenuAndSearch,
        });
      },
      [
        reportBi,
        language,
        trackClicksAnalytics,
        compId,
        restMapperProps.fullNameCompType,
        mainPageId,
      ],
    );

  const isCssPreHydrationEnabled = isExperimentOpen(
    experiments,
    'specs.thunderbolt.cssMegaMenuPreHydration',
  );

  return {
    ...restMapperProps,
    currentUrl,
    reportBiOnMenuItemClick,
    isCssPreHydrationEnabled,
  };
});

export default compController;
